import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./features/authSlice";
import dataSlice from "./features/dataSlice";
import stylesSlice from "./features/stylesSlice";

export default configureStore({
  reducer: {
    styles: stylesSlice,
    auth: authSlice,
    data: dataSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: Number(process.env.REACT_APP_DEV_TOOLS),
});
